import { createFileRoute } from "@tanstack/react-router"

import { AssetTypeSettingsStatusView } from "../../../../../../../../views/AssetTypeSettingsStatusView/AssetTypeSettingsStatusView"
import { assetTypeStatusViewStaticData } from "../../../../../../../../views/AssetTypeSettingsStatusView/constants"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/statuses",
)({
	component: AssetTypeSettingsStatusView,
	staticData: assetTypeStatusViewStaticData,
})
